'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.InfiniteList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactVirtualized = require('react-virtualized');

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteList = function (_PureComponent) {
	_inherits(InfiniteList, _PureComponent);

	function InfiniteList(props) {
		_classCallCheck(this, InfiniteList);

		var _this = _possibleConstructorReturn(this, (InfiniteList.__proto__ || Object.getPrototypeOf(InfiniteList)).call(this, props));

		_this.state = {
			doneFetching: false
		};

		_this.isRowLoaded = _this.isRowLoaded.bind(_this);
		_this.loadMoreRows = _this.loadMoreRows.bind(_this);
		return _this;
	}

	_createClass(InfiniteList, [{
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps) {
			var list = this.props.list;


			if (!this.isArrayEqual(list, prevProps)) {
				this.list.forceUpdateGrid();
			}
		}
	}, {
		key: 'isArrayEqual',
		value: function isArrayEqual(arr1, arr2) {
			return (0, _lodash.isEmpty)((0, _lodash.xorWith)(arr1, arr2, _lodash.isEqual));
		}
	}, {
		key: 'loadMoreRows',
		value: function loadMoreRows() {
			var _props = this.props,
			    onFetchMore = _props.onFetchMore,
			    isDoneFetching = _props.isDoneFetching;


			if (!isDoneFetching && onFetchMore && typeof onFetchMore == 'function') {
				onFetchMore();
			}
		}
	}, {
		key: 'isRowLoaded',
		value: function isRowLoaded(_ref) {
			var index = _ref.index;
			var list = this.props.list;


			return !!list[index];
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props2 = this.props,
			    className = _props2.className,
			    itemHeight = _props2.itemHeight,
			    itemCount = _props2.itemCount,
			    totalItemCount = _props2.totalItemCount,
			    itemRenderer = _props2.itemRenderer,
			    noItemsRenderer = _props2.noItemsRenderer,
			    containerHeight = _props2.containerHeight,
			    containerWidth = _props2.containerWidth,
			    fetchMoreOffset = _props2.fetchMoreOffset;


			return _react2.default.createElement(
				_reactVirtualized.InfiniteLoader,
				{
					isRowLoaded: this.isRowLoaded,
					loadMoreRows: this.loadMoreRows,
					threshold: fetchMoreOffset,
					rowCount: totalItemCount
				},
				function (_ref2) {
					var onRowsRendered = _ref2.onRowsRendered,
					    registerChild = _ref2.registerChild;
					return _react2.default.createElement(
						_reactVirtualized.AutoSizer,
						{
							disableHeight: !!containerHeight,
							disableWidth: !!containerWidth
						},
						function (_ref3) {
							var height = _ref3.height,
							    width = _ref3.width;
							return _react2.default.createElement(_reactVirtualized.List, {
								ref: function ref(node) {
									_this2.list = node;
									registerChild(node);
								},
								onRowsRendered: onRowsRendered,
								className: 'infinite-list ' + className,
								height: containerHeight || height,
								width: containerWidth || width,
								rowCount: itemCount,
								rowHeight: itemHeight,
								rowRenderer: itemRenderer,
								noRowsRenderer: noItemsRenderer
							});
						}
					);
				}
			);
		}
	}]);

	return InfiniteList;
}(_react.PureComponent);

InfiniteList.propTypes = {
	className: _propTypes2.default.string,
	itemClassName: _propTypes2.default.string,
	containerHeight: _propTypes2.default.number,
	containerWidth: _propTypes2.default.number,
	fetchMoreOffset: _propTypes2.default.number,
	isDoneFetching: _propTypes2.default.bool,
	list: _propTypes2.default.array,
	totalItemCount: _propTypes2.default.number,
	onFetchMore: _propTypes2.default.func,
	itemHeight: _propTypes2.default.number.isRequired,
	itemCount: _propTypes2.default.number.isRequired,
	itemRenderer: _propTypes2.default.func.isRequired,
	noItemsRenderer: _propTypes2.default.func.isRequired
};
InfiniteList.defaultProps = {
	className: '',
	itemClassName: '',
	containerHeight: 0,
	containerWidth: 0,
	fetchMoreOffset: 15,
	totalItemCount: 999999,
	isDoneFetching: false,
	list: []
};
exports.InfiniteList = InfiniteList;